module.exports = __webpack_public_path__ + "static/media/logout.28b47202.svg";